import {
	formatDateTime,
	getDateSortValue,
} from '@/components/views/SettingsView/BrokerageUsersTable/helpers';
import React from 'react';
import { getCountryName } from '../../shared/getCountryName';
import { lastUpdatedByColumn } from '../../shared/lastUpdatedByColumn';
import { createdAtColumn, createdByColumn } from '../../shared/createdColumns';
import { BrokerGroupTimezoneCell } from './BrokerGroupTimezoneCell';

const sharepointFields = {
	flex: 1,
	minWidth: 220,
};

/**
 * Columns for the admin broker groups list (read only, sorted in the browser). Cells that
 * show something other than the stored value use a valueFormatter, so the export matches
 * the table: country is a code (countryCode: the stored country, or else the config's; see
 * listAllBrokerGroups) shown by name, state and timezone come from the config (a timezone
 * that doesn't fit the country is shown in error), and tenant access is whether
 * the broker group has a tenant.
 */
export const brokerGroupColumns = [
	{
		field: 'name',
		headerName: 'Name',
		flex: 1,
		minWidth: 200,
		hideable: false,
	},
	{
		field: 'id',
		headerName: 'Id',
		width: 220,
	},
	{
		field: 'ledger',
		headerName: 'Ledger',
		minWidth: 160,
	},
	{
		field: 'countryCode',
		headerName: 'Country',
		width: 160,
		valueFormatter: (value) => getCountryName(value),
	},
	{
		field: 'state',
		headerName: 'State',
		width: 100,
	},
	{
		field: 'timezone',
		headerName: 'Timezone',
		width: 180,
		display: 'flex',
		renderCell: ({ row }) => <BrokerGroupTimezoneCell row={row} />,
	},
	{
		field: 'branchId',
		headerName: 'Insight branch id',
		width: 150,
	},
	{
		field: 'permissionsGroup',
		headerName: 'Permissions group id',
		width: 170,
	},
	{
		field: 'lastUpdated',
		headerName: 'Last updated',
		width: 190,
		type: 'number',
		headerAlign: 'left',
		align: 'left',
		valueGetter: (value) => getDateSortValue(value),
		valueFormatter: (value, row) => formatDateTime(row.lastUpdated),
	},
	lastUpdatedByColumn,
	createdAtColumn,
	createdByColumn,
	{
		field: 'sharepointDomain',
		headerName: 'SharePoint domain',
		...sharepointFields,
	},
	{
		field: 'sharepointSiteId',
		headerName: 'SharePoint site id',
		...sharepointFields,
	},
	{
		field: 'clientSiteSuffix',
		headerName: 'Client site suffix',
		...sharepointFields,
	},
	{
		field: 'clientFolder',
		headerName: 'Client folder',
		...sharepointFields,
	},
	{
		field: 'clientFolderDriveId',
		headerName: 'Client folder drive id',
		...sharepointFields,
	},
	{
		field: 'tenant',
		headerName: 'Admin consent',
		width: 140,
		valueGetter: (value) => Boolean(value),
		valueFormatter: (value) => (value ? 'Yes' : 'No'),
	},
];

export const DEFAULT_HIDDEN_BROKER_GROUP_COLUMNS = [
	'state',
	'lastUpdatedBy',
	'createdAt',
	'createdBy',
	'sharepointDomain',
	'sharepointSiteId',
	'clientSiteSuffix',
	'clientFolder',
	'clientFolderDriveId',
	'tenant',
];
